@if (showMenuBtn()) {
  <button mat-button color="primary" (click)="utils.toggleSidenav()" class="menuBtn"  [class.iosMenu]="utils.ios()" [class.androidMenu]="utils.android()">
    <mat-icon>menu</mat-icon>
  </button>
}

@if (url?.includes('/activity')) {
  <button mat-button class="back" onclick="history.back(-1);window.scrollTo(0,0)" (click)="utils.sound()" [class.iosMenu]="utils.ios()" [class.androidMenu]="utils.android()">
    <mat-animated-icon start="arrow_back" end="arrow_back" colorStart="none" colorEnd="none" [animate]="flags.animate_icon"></mat-animated-icon>
  </button>
}

@if ((user == null && url?.includes('/:id/') && !url?.includes('login')) || (url?.includes('settings') && !url?.includes('returnUrl='))) {
<div  class="navbarRight" [class.ios]="utils.ios()" [class.android]="utils.android()">
  <a routerLink="/dashboard" onclick="window.scrollTo(0,0)" (click)="utils.sound('home')">
  <img src="./assets/img/activity8-logo.png" height="50" style="padding-top:12px;">
  </a>
</div>
}

@if (flags.showDownload && mobileWeb() && !isPWA() && !isStripeRedirect()) {
<div class="download animate__animated animate__fadeInDown" [class.ios]="utils.ios()">
  <button mat-button type="button" class="closeBtn" (click)="closeDownload()" [class.ios]="utils.ios()"><mat-icon>close</mat-icon></button>
  Get the app<br />
  <a href="https://play.google.com/store/apps/details?id=com.activity8.app&hl=en_IE&gl=US"><img src="https://www.activity8.com/wp-content/uploads/2021/04/download-android-white-300x90.png" /></a>
  <a href="https://apps.apple.com/us/app/activity8/id1537925959"><img src="https://www.activity8.com/wp-content/uploads/2021/04/download-ios-white-300x90.png" /></a>

</div>
}